<script setup lang="ts">
defineProps<{
  text?: string;
  disabled?: boolean;
}>();

defineOptions({
  inheritAttrs: true,
});
</script>

<template>
  <button class="pwt-theme pwt-button--base pwt-button--text" v-bind="$attrs" :disabled="disabled">
    <span class="pwt-button--text--label pwt-text-truncate">
      <slot v-if="$slots.default"></slot>
      <template v-else>{{ text }}</template>
    </span>
  </button>
</template>

<style lang="css" scoped>

@import "./styles/pwt-theme.css";
@import "./styles/pwt-utilities.css";
@import "./styles/button-shared.css";

/* text button styles */
.pwt-button--text {
  display: inline-flex;
  color: var(--palatinate-blue-100);
  text-decoration: none;
  transition:
    color 150ms ease;
}

.pwt-button--text--label {
  position: relative;
  display: inline-block;
  align-self: center;
  justify-self: center;
  padding-bottom: 2px;
}

.pwt-button--text:hover {
  color: var(--palatinate-blue-120);
}

.pwt-button--text:active {
  color: var(--palatinate-blue-140);
}

.pwt-button--text:disabled {
  color: var(--light-gray);
  cursor: default;
}

.pwt-button--text--label::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;

  width: 100%;
  height: 1px;

  background: currentColor;

  transform: scaleX(0);
  transform-origin: left;

  transition: transform 200ms ease;
}

.pwt-button--text:not(:disabled):hover .pwt-button--text--label::after {
  transform: scaleX(1);
}

</style>
